import { Type } from 'class-transformer';
import { IsInt, IsOptional, IsString, ValidateNested } from 'class-validator';
import { DimensionDto } from './file-thumbnail.dto';

export class AwsS3MetadataDto {
  @IsString()
  bucket!: string;

  @IsString()
  region!: string;

  @IsString()
  folder!: string;

  @IsString()
  filename!: string;

  @IsOptional()
  @IsString()
  requestId?: string;

  @IsOptional()
  @IsString()
  eTag?: string;

  @IsOptional()
  @IsInt()
  attempts?: number;

  @IsOptional()
  @ValidateNested()
  @Type(() => DimensionDto)
  dimension?: DimensionDto;
}

export class FileLocalhostMetadataDto {
  @IsString()
  folder!: string;

  @IsString()
  filename!: string;

  @IsString()
  eTag!: string;

  @IsString()
  bucket!: string;

  @IsInt()
  attempts!: number;

  @IsOptional()
  @ValidateNested()
  @Type(() => DimensionDto)
  dimension?: DimensionDto;
}

export class FileProviderMetadataDto {
  @IsOptional()
  @ValidateNested()
  @Type(() => AwsS3MetadataDto)
  aws?: AwsS3MetadataDto;

  @IsOptional()
  @ValidateNested()
  @Type(() => FileLocalhostMetadataDto)
  localhost?: FileLocalhostMetadataDto;
}
